import { DTOObjectMeta } from "../aux";
import { z } from "zod";
//
// Read
//
export const DTODesignSystemComponent = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    brandId: z.string(),
    meta: DTOObjectMeta,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DTODesignSystemComponentResponse = z.object({
    designSystemComponent: DTODesignSystemComponent,
});
export const DTODesignSystemComponentListResponse = z.object({
    designSystemComponents: DTODesignSystemComponent.array(),
});
//
// Write
//
export const DTODesignSystemComponentCreateInput = z.object({
    brandId: z.string(), // Persistent ID,
    persistentId: z.string(),
    meta: DTOObjectMeta,
});
